import type { AssetDetailsPanelState } from '../../../../generated';
import { ReactiveMap } from '../../../../utils/ReactiveMap';

export const assetDetailsPanelStateMap = new ReactiveMap<
  string,
  AssetDetailsPanelState,
  'assetDetailsPanelState'
>();
